import React, { useState, createContext, useEffect } from 'react';
import PropTypes from 'prop-types';

export const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(prevIsOpen => !prevIsOpen);
  };

  // Log l'état à chaque changement
  useEffect(() => {
    // console.log('Le menu est :', isOpen ? 'ouvert' : 'fermé');
  }, [isOpen]);

  return (
    <MenuContext.Provider value={{ isOpen, toggleOpen }}>
      {children}
    </MenuContext.Provider>
  );
};

MenuProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'light';
  });

  const toggleTheme = () => {
    setTheme(prevTheme => {
      const newTheme = prevTheme === 'light' ? 'dark' : 'light';
      localStorage.setItem('theme', newTheme);
      return newTheme;
    });
  };

  useEffect(() => {
    // console.log("Thème appliqué :", theme);
    if (theme === 'dark') {
      document.documentElement.classList.add('dark'); // Ajoute "dark" sur <html>
    } else {
      document.documentElement.classList.remove('dark'); // Retire "dark" de <html>
    }

    // const themeInLocalStorage = localStorage.getItem('theme');
    // if (themeInLocalStorage) {
    //   // console.log("Thème localStorage :", themeInLocalStorage);
    // }
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
